// extracted by mini-css-extract-plugin
module.exports = {"mobileLeaveMeetingWrapper":"MobileLeaveMeeting_mobileLeaveMeetingWrapper__5nBp_","mobileLeaveMeetingButtonHolder":"MobileLeaveMeeting_mobileLeaveMeetingButtonHolder__2UNWa"};